import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { authorizeTelegram } from "../../api/auth";
import useTelegram from "../../hooks/useTelegram";

function ProtectedRoute() {
    const [isAuth, setIsAuth] = useState(() => {return !!localStorage.getItem("Token")});
    const location = useLocation();
    const { initData } = useTelegram();
    const shouldAuthorize = !isAuth && !!initData;

    const {data: authData, isSuccess: authSuccess} = useQuery({
        queryKey: ["tgLogin", initData],
        queryFn: () => authorizeTelegram(initData),
        enabled: shouldAuthorize,
        retry: false,
        staleTime: Infinity,
    });

    useEffect(() => {
        if (authData && authSuccess) {
            localStorage.setItem("Token", authData.token);
            localStorage.setItem("User-Id", authData.user_id);
            setIsAuth(true);
        }
    }, [authData, authSuccess]);

    if (shouldAuthorize) return null;

    return isAuth ? <Outlet /> : <Navigate to="/login" replace state={{from: location.pathname}} />;
}

export default ProtectedRoute;